import React from "react"
import { Stack } from "@mui/material"

export default function FormContainer({ children, ...props }) {
	return (
		<Stack height="100%" {...props}>
			{children}
		</Stack>
	)
}
